export { default } from './BorrowingLayout.jsx';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingLayout/index.js